/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { encryption } from '../../auth/utilities';
import { useSubdomain, deriveSubdomainFromEmail } from '../../context/SubdomainContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faLock, faEnvelope, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import pattern from '../../assets/authentication/signup_pattern.png';
import logo from '../../assets/logos/whizzc_logo.png';
import animated_img from '../../assets/authentication/animated_compliance_img.png';
import google_sso from '../../assets/authentication/google_icon_sso.png';
import '../../styles/signup.css';
import Cookies from 'js-cookie';

const LoginForm = ({ isAuthenticated, UpdateAuthentication }) => {
    const [loginStatus, setLoginStatus] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
    const { subdomain, setSubdomain } = useSubdomain();
    const [isCheckingTenant, setIsCheckingTenant] = useState(false);

    const getSession = async (tenant) => {
        try {
            const res = await fetch(process.env.REACT_APP_BACKEND + tenant + '/auth/authenticate/', {
                credentials: "include",
            });
            const data = await res.json();
            if (res.status === 200 || res.status === 202) {
                if (data.is_authenticated) {
                    Cookies.set("csrftoken", data.csrftoken, { path: '/' });
                    return true;
                } else {
                    return false;
                }
            } else {
                console.log("Network response was not ok");
                return false;
            }
        } catch (err) { console.log("session not created") }
    }

    const ensureTenant = async (tenant) => {
        try {
            setIsCheckingTenant(true);
            const res = await fetch(process.env.REACT_APP_BACKEND + tenant + '/auth/checktenant');
            if (!res.ok) return false;
            const data = await res.json();
            return data.tenant === true;
        } catch (err) {
            return false;
        } finally {
            setIsCheckingTenant(false);
        }
    };

    const handleSubmit = async (event) => {
        setLoginStatus("Logging In");
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const email = formData.get("email")?.trim();
        const derivedSubdomain = deriveSubdomainFromEmail(email);

        if (!derivedSubdomain) {
            setErrorMessage("Unable to determine organization from email domain");
            setLoginStatus("Error");
            return;
        }

        setSubdomain(derivedSubdomain);

        const tenantAvailable = await ensureTenant(derivedSubdomain);
        if (!tenantAvailable) {
            setErrorMessage("Tenant not found for this email domain");
            setLoginStatus("Tenant not found");
            return;
        }

        const request = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
                username: formData.get("email"),
                password: formData.get("password")
            })
        };
        try {
            const res = await fetch(process.env.REACT_APP_BACKEND + derivedSubdomain + "/auth/tenantlogin/", request, { credentials: 'include' });
            if (res.status === 200 || res.status === 202) {
                setLoginStatus("Logged In Successfully");
                const data = await res.json();
                setSubdomain(data.subdomain || derivedSubdomain);
                const session = await getSession(data.subdomain || derivedSubdomain);
                if (session != null) {
                    if (session === true) {
                        Cookies.set("isAuthenticated", true, { path: "/" });
                        Cookies.set("user_name", encryption(data.user_name), { path: "/" });
                        Cookies.set("profile_name", encryption(data.profile_name), { path: "/" });
                        Cookies.set("tenant", encryption(data.subdomain), { path: "/" });
                        Cookies.set("tenant_id", encryption(data.tenant_id.toString()), { path: "/" });
                    } else {
                        Cookies.set("user_name", null, { path: "/" });
                        Cookies.set("profile_name", null, { path: "/" });
                        Cookies.set("isAuthenticated", false, { path: "/" });
                        Cookies.set("tenant", null, { path: "/" });
                        Cookies.set("tenant_id", null, { path: "/" });
                        alert("You entered wrong credentials");
                    }
                }
            } else if (res.status === 400) {
                const json = await res.json();
                if (json.error === "invalid_email") {
                    setErrorMessage("Invalid Email");
                } else if (json.error === "invalid_password") {
                    setErrorMessage("Invalid Password");
                } else {
                    setErrorMessage("Incorrect Email or Password, please try again");
                }
                setLoginStatus("Incorrect Email or Password, please try again");
                console.log(errorMessage);
            } else {
                const json = await res.json();
                alert(json);
                setLoginStatus("Error");
            }
        } catch (error) {
            setLoginStatus("Error");
        }
    }

    const togglePasswordVisibility = () => {
        setShowPassword(prevState => !prevState);
    };

    return (
        <div className='login_container'>
            <span><img src={logo} alt="" id='logo' /></span>
            <img src={pattern} alt="" className='pattern' />
            <div className='content_container login'>
                <section className='left_side_container'>
                    <img src={animated_img} alt="" />
                    <h1 className='left_container_phrase'>STAY CONFIDENT AND <span id='compliant'>COMPLIANT</span> WITH WHIZZC</h1>
                </section>
                <section className='right_side_container'>
                    <h2 className='welcome_to_whizzc'>Welcome to Whizz<span id='C_of_whizzC'>C</span></h2>
                    <section className='input_fields_container'>
                        <h3>Login with your organization email address</h3>
                        <form action="" onSubmit={handleSubmit}>
                            <div className="input-group">
                                <FontAwesomeIcon icon={faEnvelope} className='input_icons' style={{ color: '#A4A4A4' }} />
                                <input type="email" name='email' placeholder="Enter Email Address *" required />
                            </div>
                            <div className="input-group">
                                <FontAwesomeIcon icon={faLock} className='input_icons' style={{ color: '#A4A4A4' }} />
                                <input type={showPassword ? "text" : "password"} name='password' placeholder="Enter Password *" id="login_passwd" required />
                                <FontAwesomeIcon 
                                    icon={showPassword ? faEyeSlash : faEye} 
                                    className='input_icons' 
                                    onClick={togglePasswordVisibility} 
                                    style={{ cursor: 'pointer', color: '#A4A4A4', marginLeft: '85%' }}
                                />
                            </div>
                            {errorMessage && <div className='error-message'>{errorMessage}</div>}
                            {isCheckingTenant && <div className='info-message'>Checking tenant…</div>}
                            <button type='submit' className='login_btn'>Login</button>
                        </form>
                        <div className='links'>
                            <Link to="/ForgotPassword"><p id='forgot_password_link'>Forgot Password?</p></Link>
                        </div>
                        {/* <div className='line loginpage'></div>
                        <p id='continue_with'>Or continue with</p>
                        <section className='sso_options'>
                            <button id='google_sso_btn'><img src={google_sso} alt="" />Google</button> */}
                            {/* <button id='microsoft_sso_btn'><img src={microsoft_sso} alt="" />Microsoft</button> */}
                        {/* </section> */}
                    </section>
                </section>
            </div>
        </div>
    );
}

export default LoginForm;
